/*-------------------------------------------- */
/** Globals */
/*-------------------------------------------- */
import './globals/auth'
import './globals/components-global'
import './globals/_base'
import './globals/header-promo-bar'

/*-------------------------------------------- */
/** Lib */
/*-------------------------------------------- */


/*-------------------------------------------- */
/** Components */
/*-------------------------------------------- */
import './components/dropdown'
import './components/dropdown-mobile'
import './components/cart-message'

/*-------------------------------------------- */
/** Router */
/*-------------------------------------------- */
import('./router').then((router) => {
  router.init()
})
